import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';
import VBox from '../VBox';
import Month from './Month';
import Year from './Year';

export default function YearMonth(props) {
  const {
    month,
    year,
  } = props || {};
  return (
    <VBox {...ex('YearMonth', props)}>
      <Month {...{ month }} />
      <Year {...{ year }} />
    </VBox>
  );
}
